module.exports = __webpack_public_path__ + "img/submit.f43ac42b.png";